import { GetAllSitesRequest, GetNetworkCombosRequest, GetActivityTitlesRequest } from '../requers/siteRequest';

export const SITES_LOADING   = 'SITES_LOADING';
export const SITES_SUCCESS   = 'SITES_SUCCESS';
export const SITES_ERROR     = 'SITES_ERROR';
export const FILTERS_UPDATE  = 'FILTERS_UPDATE';
export const COMBOS_SUCCESS  = 'COMBOS_SUCCESS';
export const TITLES_SUCCESS  = 'TITLES_SUCCESS';

let _fetchSeq = 0;

export const loadNetworkCombos = () => async (dispatch) => {
	try {
		const res = await GetNetworkCombosRequest();
		dispatch({ type: COMBOS_SUCCESS, payload: res.data });
	} catch (err) {
		console.error('[loadNetworkCombos]', err?.message);
	}
};

export const loadAllSites = () => async (dispatch, getState) => {
	const { filters } = getState().sites;
	const token = ++_fetchSeq;
	dispatch({ type: SITES_LOADING, token });
	try {
		const res = await GetAllSitesRequest(filters);
		dispatch({ type: SITES_SUCCESS, payload: res.data, token });
	} catch (err) {
		if (_fetchSeq !== token) return;
		const msg = err?.response?.data?.message || err?.response?.statusText || err?.message || 'Unknown error';
		dispatch({ type: SITES_ERROR, payload: `${err?.response?.status || ''} ${msg}`, token });
	}
};

export const loadActivityTitles = () => async (dispatch, getState) => {
	const { filters } = getState().sites;
	try {
		const res = await GetActivityTitlesRequest(filters);
		dispatch({ type: TITLES_SUCCESS, payload: res.data || [] });
	} catch (err) {
		console.error('[loadActivityTitles]', err?.message);
	}
};

// Apply button + activity status toggle.
// Reloads both sites and titles with the new filters.
export const applyFilters = (newFilters) => (dispatch) => {
	dispatch({ type: FILTERS_UPDATE, payload: newFilters });
	dispatch(loadAllSites());
	dispatch(loadActivityTitles());
};